import script from "./PlanSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanSummary.vue?vue&type=script&setup=true&lang=js"

import "./PlanSummary.vue?vue&type=style&index=0&id=6b9451ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b9451ad"]])

export default __exports__